import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent {
  public Error: string = "";
  public Description: string = "";

  constructor( activatedRoute: ActivatedRoute, router: Router){
  this.Error = activatedRoute.snapshot.queryParamMap.get("error") ?? "";
  this.Description = activatedRoute.snapshot.queryParamMap.get("error_description") ?? "";

  }
}
